<template>
    <div class="reminderView">
        
    </div>
</template>